import { Routes, Route } from "react-router-dom";

import Login from "./login";
import NotFoundPage from "./notfound";
import RecoveryPage from "./recovery/RecoveryPage";
import { useEffect, useLayoutEffect, useState } from "react";
import { Box } from "@mui/material";
import { useThemeMode } from "../../components/DarkModeWrapper";

/**
 * PublicRoutes - Creates public routes do access options
 * @component
 */
const PublicRoutes = () => {
    return (
        <Box className="gtr-public-theme">
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/recovery" element={<RecoveryPage />} />
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </Box>
    );
};

const MediaBoxLoader = () => (
    <Box
        className="tw-flex tw-min-h-[100dvh] tw-w-full tw-items-center tw-justify-center tw-bg-slate-100"
        sx={{
            minHeight: "100dvh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }}
    >
        <div className="tracker-loading-main">
            <div className="ld-tracker ld-tracker-main">
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </Box>
);

const PublicApp = () => {
    const [loading, setLoading] = useState(true);
    const { setColorModeEnabled } = useThemeMode();

    useLayoutEffect(() => {
        setColorModeEnabled(false);
        return () => setColorModeEnabled(true);
    }, [setColorModeEnabled]);

    useEffect(() => {
        try {
            const isInIframe = window.self !== window.top;

            if (isInIframe) {
                setLoading(true);
            } else {
                setLoading(false);
            }
        } catch {
            // Se der erro de cross-origin, assume que está em iframe
            setLoading(true);
        }
    }, []);

    if (loading) {
        return <MediaBoxLoader />
    };

    return <PublicRoutes />
};

export default PublicApp;
